"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledge.list': 'Base de conocimientos',
    'route.knowledge.create': 'Agregar conocimiento',
    'route.knowledge.edit': 'Editar conocimiento',
    'route.knowledge.preview': 'Detalles del Conocimiento',
    'route.knowledge.bulk_upload': 'Carga masiva de conocimiento',
};
